export default __webpack_public_path__ + "static/media/Rayquaza-Pokemon.a044dc7d.mp4";